import { friendlyErrorMessage } from '@/core/lib/dbError'
import { assertWriteIdentity, captureWriteIdentity, type WriteIdentity } from '@/core/api/http'

import { generateDocument } from '@/core/api/documents'
import { ok, technical, type Result } from '@/core/lib/result'

export async function renderAnwesenheitsliste(coachingId: string, identity: WriteIdentity = captureWriteIdentity()): Promise<Result<void>> {
  try {
    await generateDocument('anwesenheitsliste', { coaching_id: coachingId }, identity)
    assertWriteIdentity(identity)
    return ok(undefined)
  } catch (error) {
    assertWriteIdentity(identity)
    return technical(
      friendlyErrorMessage(error, "Anwesenheitsliste-PDF konnte nicht erstellt werden."),
    )
  }
}
